import {Calendar} from "primereact/calendar";
import {setChangedScheduler, setCompanyField} from "../../../../redux/actions/actions";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import React, {useState} from "react";
import moment from "moment";
import {classNames} from "primereact/utils";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";

const TimeFromTo = (props: any) => {
    const dispatch = useAppDispatch();
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData);
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const statusDone = companiesData?.campaign?.statusId === 6;
    const editType = useAppSelector(state => state.UsersReducer.editType);

    const [isStartTimeFocused, setIsStartTimeFocused] = useState(false);
    const [isEndTimeFocused, setIsEndTimeFocused] = useState(false);
    const [startTime, setStartTime] = useState<any>(null);
    const [endTime, setEndTime] = useState<any>(null);
    const [startTimeInput, setStartTimeInput] = useState<string>("");
    const [endTimeInput, setEndTimeInput] = useState<string>("");

    moment.suppressDeprecationWarnings = true;
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Campaigns');

    const {
        // create: hasCampaignsCreatePermission,
        // update: hasCampaignsUpdatePermission,
    } = dialerPermissions;
    const isValidTime = (value: any) => {
        const format = 'HH:mm';
        return moment(value, format, true).isValid();
    };
    const handleDateChange = (date: any) => {
            return moment(date).format('MM/DD/YYYY HH:mm:ss');
    };

    const transformToDate = (dateString: any) => {
        return new Date(moment(dateString).format('MM/DD/YYYY HH:mm:ss'));
    }

    const getDefaultStartTime = () => {
        return companiesData?.scheduler?.startTime ? transformToDate(companiesData?.scheduler?.startTime) : transformToDate(props.startTime);
    }

    const getDefaultEndTime = () => {
        return companiesData?.scheduler?.endTime ? transformToDate(companiesData?.scheduler?.endTime) : transformToDate(props.endTime);
    }

    return (
        <>
            <div className="flex field col-12">
                <div className="md:col-6 p-0 pr-2">
                    <div className="time-item">
                        <span className="title">З</span>
                        <Calendar
                            appendTo="self"
                            id="icon"
                            className={classNames('flex-grow-1', {'p-invalid': errorFields?.startTime})}
                            placeholder="00:00"
                            value={isStartTimeFocused ? null : (startTime || getDefaultStartTime())}
                            showOnFocus={false}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setStartTime(e.value)}
                            onFocus={(e) => {
                                setIsStartTimeFocused(true);
                                setStartTime(null);
                                setStartTimeInput("");
                                setTimeout(() => {
                                    e.target.value = "";
                                }, 0);
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = startTime ? new Date(startTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setStartTime(base);
                                        dispatch(setChangedScheduler(true));
                                        dispatch(setCompanyField({section: 'scheduler', fieldName: 'startTime', value: handleDateChange(base)}));
                                    }
                                }
                            }}
                            onBlur={() => {
                                setIsStartTimeFocused(false);
                                if (!startTime) {
                                    setStartTime(getDefaultStartTime());
                                }
                            }}
                            disabled={!props.archiveTableToggle || statusDone || !editType}
                        />
                    </div>
                </div>
                <div className="md:col-6 p-0 pl-2">
                    <div className="time-item">
                        <span className="title">По</span>
                        <Calendar
                            appendTo="self"
                            className={classNames('flex-grow-1', {'p-invalid': errorFields?.endTime})}
                            id="icon"
                            placeholder="00:00"
                            value={isEndTimeFocused ? null : (endTime || getDefaultEndTime())}
                            showOnFocus={false}
                            timeOnly
                            hourFormat="24"
                            onChange={(e) => setEndTime(e.value)}
                            onFocus={(e) => {
                                setIsEndTimeFocused(true);
                                setEndTime(null);
                                setEndTimeInput("");
                                setTimeout(() => {
                                    e.target.value = "";
                                }, 0);
                            }}
                            onInput={(e: any) => {
                                const input = e.target as HTMLInputElement;

                                let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                const HH = digits.slice(0, 2);
                                const MM = digits.slice(2, 4);

                                const display = HH + (digits.length > 2 ? ":" + MM : "");

                                if (input.value !== display) {
                                    const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                    input.value = display;
                                    input.setSelectionRange(caret, caret);
                                }

                                if (digits.length === 4) {
                                    const h = parseInt(HH, 10);
                                    const m = parseInt(MM, 10);
                                    const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                    if (valid) {
                                        const base = endTime ? new Date(endTime) : new Date();
                                        base.setHours(h, m, 0, 0);
                                        setEndTime(base);
                                        dispatch(setChangedScheduler(true));
                                        dispatch(setCompanyField({section: 'scheduler', fieldName: 'endTime', value: handleDateChange(base)}));
                                    }
                                }
                            }}
                            onBlur={() => {
                                setIsEndTimeFocused(false);
                                if (!endTime) {
                                    setEndTime(getDefaultEndTime());
                                }
                            }}
                            disabled={!props.archiveTableToggle || statusDone || !editType}
                        />
                    </div>
                </div>
            </div>
            {errorFields?.endTime && <div className="col-12 md:col-12 pt-0 pb-4 pl-5"><span className="title p-error text-sm">Час запуску не може перевищувати час завершення*</span></div>}
        </>
    );
};

export default TimeFromTo;
